import { z } from 'zod'

export const applicationsSubject = z.tuple([
  z.literal('access'),
  z.literal('Applications'),
])

export type ApplicationsSubject = z.infer<typeof applicationsSubject>
